// extracted by mini-css-extract-plugin
module.exports = {"discBarChart":"DISCBarChart_discBarChart__lZZpu","double":"DISCBarChart_double__yTnfX"};